module.exports = __webpack_public_path__ + "static/media/activity-empty.b7f456e6.svg";